// src/pages/TwitterSuccess.jsx

import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import API from "../services/api";
import {
  initiateFlutterwavePayment,
  initiatePayment, //paystack (future )
} from "../services/payments";

const TwitterSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const run = async () => {
      const params = new URLSearchParams(location.search);
      const token = params.get("token");

      if (token) {
        localStorage.setItem("token", token);
      }

      // Get pending product
      const pendingProduct = localStorage.getItem("pending_product");
      const pendingId = localStorage.getItem("pending_product_id");

      let product = null;

      if (pendingProduct) {
        product = JSON.parse(pendingProduct);
      } else if (pendingId) {

        // fetch products by ID
        const res = await API.get("/products/");
        product = res.data.find(p => p.id === parseInt(pendingId));
      }

      if (!product) {
        navigate("/");
        return;
      }

      try {

        // Ensure email exists
        let email = localStorage.getItem("email");

        if (!email) {
          email = `user_${Date.now()}@creator.app`;
          localStorage.setItem("email", email);
        }
        let res;
        // MVP flutterwave default
        const provider = "flutterwave";

        if (provider ==="flutterwave") {
          res = await initiateFlutterwavePayment ({
            email,
            amount: product.price || 0, // fallback safe,
            product_id: product.id,
          });
        } else {
          // paystack fallback (future ready)

          res = await initiatePayment({
            email,
            amount: product.price || 0, // fallback safe,
            product_id: product.id,
          });
        }

        console.log("AUTO PAYMENT RESPOSE:", res);

        // Universal Url extraction
        const paymentUrl = 
          res?.data?.link || // Flutterwave ✅
          res?.authorization_url || // Paystack
          res?.data?.authorization_url ||
          res?.data?.data?.authorization_url;

        // clear saved product
        localStorage.removeItem("pending_product");
        localStorage.removeItem("pending_product_id");

        if (paymentUrl) {
          window.location.href = paymentUrl;
          return;
        }

        throw new Error (" No payment URL found");

      } catch (err) {
        console.error("Auto Payment Error:", err);
      }

      // fallback
      navigate("/"); // redirect to dashboard/home
    };

    run();
  }, [location, navigate]);

  return <div>Logging in via Twitter... Redirecting to payment....</div>;
};

export default TwitterSuccess;